import React from 'react';
import classNames from 'classnames';
import { Classes, NumberInput } from '../index';

type SliderProps = {
  min?: number;
  max?: number;
  value?: number;
  initialValue?: number;
  step?: number;
  onChange: (value: number) => void;
  className?: string;
  //zamezí změny minHodnoty
  disabledMin?: boolean;
  //zamezí změny maxHodnoty
  disabledMax?: boolean;
  //zamezí změny obou hodnot
  disabled?: boolean;
  hideNumberInput?: boolean;
  showInputBelow?: boolean;
};
export const SliderInput: React.FC<SliderProps> = ({
  min: initMin,
  max: initMax,
  value,
  initialValue: tempInitialValue,
  step = 1,
  disabled,
  className,
  onChange,
  hideNumberInput,
  showInputBelow,
}) => {
  let min = initMin || 0;
  let max = initMax || 100;
  if (!initMin && tempInitialValue && tempInitialValue < min) {
    min = tempInitialValue;
  }
  if (!initMax && tempInitialValue && tempInitialValue > max) {
    max = tempInitialValue;
  }
  const initialValue = tempInitialValue || min;
  // pole [min, max]
  const [sliderValue, setSliderValue] = React.useState(
    value ? value : initialValue
  );
  const [tempValue, setTempValue] = React.useState(value || initialValue);
  React.useEffect(() => {
    if (value) {
      setSliderValue(value);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    e.preventDefault();
    const newVal = Math.min(+e.target.value, max);
    if (!value) setSliderValue(newVal);
    onChange(newVal);
    setTempValue(newVal);
  };
  const handleInputChange = (val: number) => {
    if (disabled) return;
    if (val < min) val = min;
    if (val > max) val = max;
    if (!value) setSliderValue(val);
    onChange(val);
    setTempValue(val);
  };
  const minPos = ((sliderValue - min) / (max - min)) * 100;

  return (
    <div
      className={classNames(className, Classes.SLIDER, {
        [Classes.SLIDER_SHOW_INPUT_BELOW]: showInputBelow,
      })}
    >
      {!hideNumberInput && !showInputBelow && (
        <NumberInput
          className={Classes.SLIDER_NUMBER_INPUT_LEFT}
          disabled={disabled}
          value={tempValue}
          onChange={(val) => setTempValue(val || tempValue)}
          onSearch={() => handleInputChange(tempValue)}
          onBlur={(value) => handleInputChange(value || tempValue)}
        />
      )}
      <div className={Classes.SLIDER_WRAPPER}>
        <div className={Classes.SLIDER_INPUT_WRAPPER}>
          <input
            className={Classes.SLIDER_INPUT}
            type="range"
            value={sliderValue}
            min={min}
            max={max}
            step={step}
            onChange={handleChange}
          />
        </div>

        <div className={Classes.SLIDER_CONTROL_WRAPPER}>
          <div
            className={classNames(Classes.SLIDER_CONTROL, {
              [Classes.SLIDER_DISABLED_CONTROL]: disabled,
            })}
            style={{ left: `${minPos}%` }}
          />
          <div className={Classes.SLIDER_RAIL}>
            <div
              className={Classes.SLIDER_INNER_RAIL}
              style={{ left: `0`, right: `${100 - minPos}%` }}
            />
          </div>
        </div>
      </div>
      {!hideNumberInput && showInputBelow && (
        <NumberInput
          className={Classes.SLIDER_NUMBER_INPUT_LEFT}
          disabled={disabled}
          value={tempValue}
          onChange={(val) => setTempValue(val || tempValue)}
          onSearch={() => handleInputChange(tempValue)}
          onBlur={(value) => handleInputChange(value || tempValue)}
        />
      )}
    </div>
  );
};
